export function currentUserIsAdmin() {
  return sessionStorage.getItem('csl_user_is_admin') === 'true'
}

export default {
  currentUserIsAdmin,
}
